import React from 'react';

import { Grid } from 'semantic-ui-react';

const GridColumnHeader = ({ label }) => (
  <Grid.Column width={6} style={{ fontWeight: 'bold', fontSize: 12 }}>{label}</Grid.Column>
);

const GridColumnInfo = ({ info }) => (
  <Grid.Column width={10} style={{ fontSize: 12 }}>{info}</Grid.Column>
);

const ReportDetails = ({ fields = [], title = 'Report Details' }) => {
  if (!fields.length) return null;

  return (
    <>
      <h2>{title}</h2>
      <div style={{ backgroundColor: '#fbfbfe', borderRadius: 4 }}>
        <Grid columns={2} style={{ marginTop: 20, marginLeft: 5, marginRight: 5 }}>
          {fields.map(field => (
            <Grid.Row style={{ padding: '0.5rem 0' }} key={field.label}>
              <GridColumnHeader label={field.label} />
              <GridColumnInfo info={field.info} />
            </Grid.Row>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default ReportDetails;
